import { render } from "./LightControls.vue?vue&type=template&id=68bfd987&scoped=true"
import script from "./LightControls.vue?vue&type=script&lang=js"
export * from "./LightControls.vue?vue&type=script&lang=js"

import "./LightControls.vue?vue&type=style&index=0&id=68bfd987&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bfd987"]])

export default __exports__